import { Component} from "@eastsideco/salvo-ts";
import { ThemeComponent } from "@/theme/ThemeComponent";
import { cart } from "@/theme/Cart";
import type { SubscriptionForm } from "../SubscriptionForm/SubscriptionForm";

/**
 * Product Details
 */
@Component
export class ProductDetails extends ThemeComponent {

    private newMarkup: HTMLElement|null = null;

    init() {
        // Subscribe to cart updates and change messaging accordingly
        this.$subscribe(cart.onChangeByInteraction, () => this.updateMessaging());
    }

    async updateMessaging() {

        // Get the selected radio
        const selectedOption = document.querySelector('.product-form__subscription-choice:checked');
        const selectedOptionFrequencyUnit = selectedOption?.getAttribute('data-frequency-unit') || 'days';
        const selectedOptionFrequency = selectedOption?.getAttribute('data-frequency');

        const url = new URL(window.location.href)
        url.searchParams.set('sections','product-main');
        if(selectedOptionFrequency) {
            url.searchParams.set(selectedOptionFrequencyUnit, selectedOptionFrequency);
        }
        const res = await fetch(url).then(response => response.json())

        // Create new dom element
        const sectionMarkup = document.createElement('div');
        sectionMarkup.innerHTML = res['product-main'];
        this.newMarkup = sectionMarkup;

        // Update component elements with new markup
        this.updateElement('.absoluter-banner');
        this.updateFromPrice();

        /*
            Use the existing price update function for updatig prices because
            otherwise component refs break
        */
        const subscriptionForm = document.querySelector('subscription-form') as SubscriptionForm;
        if (subscriptionForm) {
            subscriptionForm.updatePriceElements();
        }

    }

    updateElement(selector: string) {
        if (this.newMarkup) {
            // Replace existing page element with updated element markup
            const newAbsoluterBannerElement = this.newMarkup.querySelector(selector);
            const currentAbsoluterBannerElement = this.querySelector(selector);
            if (newAbsoluterBannerElement && currentAbsoluterBannerElement) {
                currentAbsoluterBannerElement.outerHTML = newAbsoluterBannerElement.outerHTML;
            }
        }
    }

    /*
        This needs to get an attribute on the component because the price element
        is hidden when getting page markup with a selected frequency in the query string
    */
    updateFromPrice() {
        if (this.newMarkup) {
            // Replace existing page element with updated element markup
            const newFromPrice = this.newMarkup.querySelector('product-details')?.getAttribute('from-price');
            const currentFromPriceElement = this.querySelector('.product-main__details__price-amount');
            if (newFromPrice && currentFromPriceElement) {
                currentFromPriceElement.innerHTML = newFromPrice;
            }
        }
    }

}
